import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "flex align-items-center justify-content-between px-4 py-3 bg-custom-green sticky top-0" }
const _hoisted_2 = { class: "flex gap-2" }
const _hoisted_3 = {
  key: 4,
  class: "avatar-menu-container"
}
const _hoisted_4 = { class: "rr" }
const _hoisted_5 = ["src"]

import { ref, computed, watch } from 'vue';
import Button from 'primevue/button'
import Menu from 'primevue/menu'
import Avatar from 'primevue/avatar'
import { useRouter, useRoute } from 'vue-router'
import { onMounted } from "vue";
import axiosInstance from "@/api/axios";
import avatarImage from '@/assets/images/avatar.png';


export default {
  __name: 'TopNav',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const mobileMenu = ref()
const user = ref({})
const windowWidth = ref(window.innerWidth)

const login = () => router.push('/login')
const register = () => router.push('/register?type=client')
const registerSpecialist = () => router.push('/register?type=specialist')
const isAuth = () => {
    return localStorage.getItem('token') ? true : false
}
const isPro = ref(false);

// Check if mobile menu should be shown based on current route
const showMobileMenu = computed(() => {
    const currentPath = route.path
    return !currentPath.startsWith('/account') && !currentPath.startsWith('/administration')
})

// Check if current route is an account page
const isAccountPage = computed(() => {
    const currentPath = route.path
    return currentPath.startsWith('/account')
})

const isAdminPage = computed(() => {
    const currentPath = route.path
    return currentPath.startsWith('/administration')
})

// Check if avatar dropdown should be shown (only for logged in users on desktop, or all users on mobile)
const showAvatarDropdown = computed(() => {
    return showMobileMenu.value && (isAuth() || windowWidth.value <= 750)
})

// Mobile menu items based on authentication status
const mobileMenuItems = computed(() => {
    if (isAuth()) {
        return [
            {
                label: 'Moje konto',
                icon: 'pi pi-user',
                command: () => router.push('/account/settings')
            },
            { separator: true },
            {
                label: 'Wyloguj się',
                icon: 'pi pi-sign-out',
                command: () => logout()
            }
        ]
    } else {
        return [
            {
                label: 'Zaloguj się',
                icon: 'pi pi-sign-in',
                command: () => router.push('/login')
            },
            {
                label: 'Zarejestruj się',
                icon: 'pi pi-user-plus',
                command: () => router.push('/register?type=client')
            },
            {
                label: 'Dodaj swój biznes',
                icon: 'pi pi-briefcase',
                command: () => router.push('/register?type=specialist')
            }
        ]
    }
})

const toggleMobileMenu = (event) => {
    mobileMenu.value.toggle(event)
}

const logout = async () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/';
}

onMounted(() => {
    if (localStorage.getItem('token')) {
        getUser();
    }

    // Add window resize listener
    window.addEventListener('resize', () => {
        windowWidth.value = window.innerWidth
    })
})

const getUser = async () => {
    try {
        const url = `/users/find`;
        const response = await axiosInstance.get(url);
        if (response.status === 200) {
            localStorage.setItem('user', JSON.stringify(response.data.data))
            user.value = response.data.data
            isPro.value = response.data.data.is_pro;
        }
    } catch (error) {
        console.log(error);
    }
}

return (_ctx, _cache) => {
  const _component_UserMenu = _resolveComponent("UserMenu")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex align-items-center gap-2 logo-header" }, [
      _createElementVNode("a", { href: "/" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Logo",
          style: {"height":"32px"}
        })
      ])
    ], -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex gap-4 font-medium text-900" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      (isAuth() === false)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            class: "hide-mobile",
            label: "Zaloguj się",
            text: "",
            severity: "success",
            onClick: login
          }))
        : _createCommentVNode("", true),
      (!isAuth())
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 1,
            class: "hide-mobile",
            label: "Zarejestruj się",
            text: "",
            severity: "success",
            onClick: register
          }))
        : _createCommentVNode("", true),
      (!isAuth())
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 2,
            class: "hide-mobile",
            label: "Dodaj swój biznes",
            severity: "success",
            onClick: registerSpecialist
          }))
        : _createCommentVNode("", true),
      (isAccountPage.value || isAdminPage.value)
        ? (_openBlock(), _createBlock(_component_UserMenu, {
            key: 3,
            "is-auth": isAuth(),
            user: user.value,
            onToggleSidebar: _cache[0] || (_cache[0] = $event => (_ctx.$emit('toggle-sidebar')))
          }, null, 8, ["is-auth", "user"]))
        : _createCommentVNode("", true),
      (showAvatarDropdown.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "flex items-center gap-3",
              onClick: toggleMobileMenu
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(Button), {
                  label: isAuth() ? user.value.display_name : 'Konto',
                  class: "p-button-text name hide-mobile"
                }, null, 8, ["label"]),
                _createVNode(_unref(Menu), {
                  ref_key: "mobileMenu",
                  ref: mobileMenu,
                  model: mobileMenuItems.value,
                  popup: true
                }, null, 8, ["model"])
              ]),
              _createVNode(_unref(Avatar), {
                image: isAuth() ? (user.value.logo_path || _unref(avatarImage)) : _unref(avatarImage),
                shape: "circle",
                size: "medium",
                class: "hide-mobile"
              }, null, 8, ["image"]),
              _createElementVNode("img", {
                src: isAuth() ? (user.value.logo_path || _unref(avatarImage)) : _unref(avatarImage),
                class: "mobile-avatar",
                alt: "Avatar"
              }, null, 8, _hoisted_5)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}